export default __webpack_public_path__ + "static/media/contact.ea900458.svg";